

export interface LogoProps {
    url: string;
    size?: "w200" | "w600" | "w1800"
}

export const CustomLogo = ({ url, size }: LogoProps) => {

    if (!url) {
        return null;
    }

    return <img src={size ? url + "?size=" + size : url} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", height: "100%" }} />
}